<template>
  <!--  푸터  -->

  <!-- <div id="section5" class="company_box type05"> -->
  <div id="footer_area">
    <div class="footer">
      <div class="footer_top">
        <div
          class="footer_link"
          @mouseover="cssfooterlink = true"
          @mouseout="cssfooterlink = false"
        >
          <button class="f_link_btn" >이용약관</button>
          <ul class="f_link" :class="{ on: cssfooterlink }">
            <li>
              <router-link
                to="/PersonalPolicy"
                @click.native="cssfooterlink = false"
              >개인정보 처리방침</router-link>
            </li>
            <li>
              <router-link to="/Email" @click.native="cssfooterlink = false">
                이메일무단 수집거부
              </router-link>
            </li>
            <li>
              <router-link
                to="/sitemap"
                @click.native="cssfooterlink = false"
              >사이트맵</router-link>
            </li>
            <li>
              <router-link
                to="/intro/location"
                @click.native="cssfooterlink = false"
              >오시는 길</router-link>
            </li>
          </ul>
        </div>
          <div
            class="family_site"
            @mouseover="cssFamilySite = true"
            @mouseout="cssFamilySite = false"

          >
            <button class="family_btn">패밀리사이트</button>
            <ul class="link" :class="{ on: cssFamilySite }">
              <li>
                <a href="https://www.dongkuk.com" target="_blank">
                  동국홀딩스
                </a>
              </li>
              <li>
                <a href="https://www.dongkuksteel.com" target="_blank">
                  동국제강
                </a>
              </li>
              <li>
                <a href="https://www.dongkukcm.com" target="_blank">
                  동국씨엠
                </a>
              </li>
              <li>
                <a href="https://www.intergis.co.kr" target="_blank">
                  인터지스
                </a>
              </li>
              <li>
                  <a href="https://www.dongkuksystems.com" target="_blank">
                    동국시스템즈
                  </a>
                </li>
              <li>
                <a href="http://www.ferruminfra.com" target="_blank">
                  페럼인프라
                </a>
              </li>
            </ul>
          </div>
      </div>

      <div class="footer_bottom">
        <router-link to="/">
          <span class="footer_logo"></span>
        </router-link>
        <p class="address">
          <span>송원문화재단 사무국 :</span> 부산광역시 남구 전포대로 133, 3710호(문현동, IFC부산오피스텔)  |  (051)611-5459<br>
          <span>송원아트센터(미술관) :</span> 서울특별시 종로구 윤보선길 75(화동)  |  (02)735-9277
        </p>
        <div class="sns_wrap">
            <div class="footer_sns">
                <a href="https://talk.naver.com/ct/w44dei?frm=mnmb&frm=nmb_detail" target="blank">
                  <div><img :src="require('./../../assets/img/ntalk.png')"></div>
                  <div>네이버톡톡 문의하기</div>
                </a>
            </div>
      </div>
        <p class="copyright">COPYRIGHT© 2023 SONGWON CULTURE FOUNDATION CO.,Ltd. ALL RIGHTS RESERVED.</p>
      </div>

    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  data: () => ({
    message: "Footer.vue",
    cssFamilySite: false,
    cssfooterlink: false
  }),
  methods: {},
  computed: {

    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue